import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InvalidezHomeComponent } from './pages/invalidez-home/invalidez-home.component';
import { TramitePensionInvalidezRoutesModule } from './tramite-pension-invalidez-routes.module';


@NgModule({
  imports: [
    CommonModule,
    TramitePensionInvalidezRoutesModule,
    InvalidezHomeComponent,    
  ]  
})
export class TramitePensionInvalidezModule {}
